import UserDetailModal from './user-detail-modal.vue'
export default UserDetailModal
